import { Button, Chip, Stack, Typography, useTheme } from "@mui/material";

import { CCardHeader } from "@coreui/react";
import DatasetTypeChip from "./DatasetTypeChip";
import { DocumentDataCardType } from "./DocumentDataCard";
import { getSourceDisplayName } from "src/views/assistant/utils/sourceDisplayName";

type DocumentDataCardHeaderProps = {
  type: DocumentDataCardType;
  sdr_id: number;
  datasetId?: number;
  parsedChunkMetadata: any;
  parsedSDRData: any;
  index?: number;
};

const DocumentDataCardHeader = ({
  type,
  sdr_id,
  datasetId,
  parsedChunkMetadata,
  parsedSDRData,
  index,
}: DocumentDataCardHeaderProps) => {
  const theme = useTheme();

  const documentPageUrl = `/datasets/${datasetId}/document/${sdr_id}`;

  // Backend stores 1-indexed page numbers, use directly
  const pageNumbers = Array.isArray(parsedChunkMetadata?.page_number)
    ? parsedChunkMetadata.page_number
    : [parsedChunkMetadata?.page_number];

  let pageNumberString =
    pageNumbers.length > 1
      ? `${pageNumbers[0]} to ${pageNumbers[pageNumbers.length - 1]}`
      : pageNumbers[0];

  const getParsedPageNumber = (pageNumber: number | number[]): number => {
    return Array.isArray(pageNumber) ? pageNumber[0] : pageNumber;
  };

  const handleNavigateToPage = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();

    const parsedPageNumber = getParsedPageNumber(
      parsedChunkMetadata.page_number,
    );

    let newTabUrl = new URL(`${window.location.origin}${documentPageUrl}`);
    let queryParams = new URLSearchParams(newTabUrl.search);
    queryParams.set("page_number", String(parsedPageNumber));
    newTabUrl.search = queryParams.toString();

    window.open(newTabUrl.toString(), "_blank", "noopener,noreferrer");
  };

  return (
    <CCardHeader
      style={{
        backgroundColor: "#f5f5f5",
        fontWeight: "bold",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
        flexWrap="wrap"
      >
        <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
          {index && (
            <Chip
              label={index}
              size="small"
              sx={{
                fontWeight: "normal",
                border: `1px solid ${theme.palette.divider}`,
              }}
            />
          )}
          <DatasetTypeChip type="document" avatar />
          <Typography
            variant="subtitle1"
            title={parsedSDRData.file_name}
            sx={{
              fontWeight: 600,
              wordBreak: "break-word",
              color: theme.palette.text.primary,
            }}
          >
            {getSourceDisplayName(parsedSDRData)}
          </Typography>
          {pageNumberString !== undefined && pageNumberString !== null && (
            <Chip
              label={`Page ${pageNumberString}`}
              size="small"
              variant="outlined"
              sx={{ fontWeight: "normal" }}
            />
          )}
        </Stack>

        <Button
          variant="contained"
          size="small"
          onClick={handleNavigateToPage}
          hidden={type !== "search" || datasetId == null}
          data-attr="datasets:btn:view-document-page"
        >
          View Page
        </Button>
      </Stack>
    </CCardHeader>
  );
};

export default DocumentDataCardHeader;
